import "./index_page.scss"; import "./index.js"
